export const POST_MAILCHIMP_REQUEST = 'postMailChimpReducer/POST_MAILCHIMP_REQUEST';
export const POST_MAILCHIMP_SUCCESS = 'postMailChimpReducer/POST_MAILCHIMP_SUCCESS';
export const POST_MAILCHIMP_FAILED = 'postMailChimpReducer/POST_MAILCHIMP_FAILED';